// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import { Loader } from "../../common/Loaders/Loader";

export const DangerBtn = ({ text, loading, submit = null, className = "", style = {}, dataTestId = "" }) => {
  return (
    <button
      type="button"
      className={`btn btn-secondary yoom-text-error ${className}`}
      onClick={submit}
      style={style}
      data-testid={dataTestId}
    >
      {!loading ? text : <Loader />}
    </button>
  );
};

DangerBtn.propTypes = {
  loading: PropTypes.bool,
  text: PropTypes.string,
  submit: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  dataTestId: PropTypes.string,
};
